<script setup>
  import { ref, computed, onMounted, watchEffect, watch } from 'vue';
  import { useSpotStore } from '@/stores/SpotStore';
  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import useLegacyBridge from "@/composables/useLegacyBridge";
  
  const { $WIND_GRAPH } = useContainerConfigurationGlobals();

  const content = defineModel('content');

  const props = defineProps({
    isNCWind: {
      type: Boolean,
      required: true
    },
    ncWindDataEnabled: {
      type: Boolean,
      required: false
    },
    selectedModelIds: {
      type: Object,
      required: false
    },
    useExternalDataBlock: {
      type: Boolean,
      default: false
    },
    useExternalControls: {
      type: Boolean,
      default: false
    },
    useClassicModelSelector: {
      type: Boolean,
      default: false
    },
    modelSelectorTarget: {
      type: HTMLElement,
      required: false
    },
    multiStationGraphData: {
      type: Object,
      required: false
    }
  })

  const spotStore = useSpotStore();

  const { currentConditions } = useLegacyBridge();

  const graphContainer = ref(null);
  const selectedModelIds = ref(props.selectedModelIds || null);
  const ncWindDataEnabled = ref(props.ncWindDataEnabled || false);

  const multiStationSettings = computed(() => {
    return {
        width: "100%",
        spotList: `${spotStore.spotId}`,
        spotId: spotStore.spotId,
        favSpotId: spotStore.spotFavoriteId,
        lat: spotStore.lat,
        lon: spotStore.lon,        
        spotName: spotStore.spotName,
        debug: "false",
        upgradeAvailable: spotStore.upgradeAvailable,
        showDataFieldsMenu: $WIND_GRAPH.show_data_fields_menu,
        showNearbySpots: $WIND_GRAPH.show_nearby_spots,
        hideData: false,
        showVirtual: $WIND_GRAPH.show_virtual,
        stationCapabilities: spotStore.stationCapabilities,
        showCurrentConditions: false,
        modelSelectorTarget: props.modelSelectorTarget,
        useExternalControls: props.useExternalControls,
        useExternalDataBlock: props.useExternalDataBlock,
        useClassicModelSelector: props.useClassicModelSelector,
    };
  });

  const singleStationSettings = computed(() => {
    const station = spotStore.spot.stations[0];

    return {
        width: "100%",
        spotId: spotStore.spotId,
        favSpotId: spotStore.spotFavoriteId,
        stationId: station.station_id,
        lat: spotStore.lat,
        lon: spotStore.lon,
        spotName: spotStore.spotName,
        debug: "false",
        spotStatus: station.status_id,
        provider: station.provider,
        spotTypeId: station.Type,
        upgradeAvailable: spotStore.upgradeAvailable,
        showDataFieldsMenu: $WIND_GRAPH.show_data_fields_menu,
        showNearbySpots: $WIND_GRAPH.show_nearby_spots,
        showVirtual: $WIND_GRAPH.show_virtual,
        showCurrentConditions: false,
        stationCapabilities: spotStore.stationCapabilities,
        hideData: true,
        isNCWind: props.isNCWind,
        ncWindDataEnabled: ncWindDataEnabled.value,
        modelSelectorTarget: props.modelSelectorTarget,
        useExternalControls: props.useExternalControls,
        useExternalDataBlock: props.useExternalDataBlock,
        useClassicModelSelector: props.useClassicModelSelector,
    };
  });

  function loadGraph() {
    const settings = spotStore.isMultiStationSpot ? multiStationSettings.value : singleStationSettings.value;     

    if (props.selectedModelIds) {
      settings.selectedModelIds = props.selectedModelIds
    }
    content.value = currentConditions(graphContainer.value, settings);

    watchEffect(() => {
      if (!props.multiStationGraphData) return;

      window.$EventBus.dispatchEvent('multi-station-list-change', props.multiStationGraphData);
    });
  }

  onMounted(() => {
    // if (!props.modelSelectorTarget || externalModelSelectorContainer.value) {
    //   loadGraph();

    //   return;
    // }
    
    watchEffect(() => {
      if (props.modelSelectorTarget) {
        loadGraph();
      }
    });

    watchEffect(() => ncWindDataEnabled.value = props.ncWindDataEnabled || false);
  })

</script>

<template>
  <div
    :id="spotStore.spotId"
    class="jwx-data-container__main-content"
    style="width: 100%;"
    ref="graphContainer"
  ></div>
</template>